import { render, staticRenderFns } from "./SlidePage.vue?vue&type=template&id=67777ab2&scoped=true&"
import script from "./SlidePage.vue?vue&type=script&lang=js&"
export * from "./SlidePage.vue?vue&type=script&lang=js&"
import style0 from "./SlidePage.vue?vue&type=style&index=0&id=67777ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67777ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\IdeaProjects\\custom_stage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67777ab2')) {
      api.createRecord('67777ab2', component.options)
    } else {
      api.reload('67777ab2', component.options)
    }
    module.hot.accept("./SlidePage.vue?vue&type=template&id=67777ab2&scoped=true&", function () {
      api.rerender('67777ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/slidePage/components/SlidePage.vue"
export default component.exports